import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedRoutingModule } from './shared-routing.module';
import { NameFormatPipe } from './pipes/name-format.pipe';
import { TranslocoRootModule } from './transloco-root.module';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { FiltersComponent } from '../dashboard/pages/admin/shared/filters/filters.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';


@NgModule({
  imports: [
    CommonModule,
    SharedRoutingModule,
    ReactiveFormsModule,
    TranslocoRootModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
  ],
  declarations: [
    NameFormatPipe,
    PaginatorComponent,
    FiltersComponent
  ],
  exports: [
    TranslocoRootModule,
    ReactiveFormsModule,
    NameFormatPipe,
    PaginatorComponent,
    FiltersComponent
  ],
  providers: [
    NameFormatPipe,
  ],
})
export class SharedModule { }
